import { useI18n } from "../i18n/I18nProvider";

export function ErrorMessage({ onRetry, message }: { onRetry?: () => void; message?: string }) {
  const { t } = useI18n();
  return (
    <div className="status status-error" role="alert">
      <p>{message ?? t("error.generic")}</p>
      {onRetry && (
        <button type="button" className="btn btn-outline" onClick={onRetry}>
          {t("error.retry")}
        </button>
      )}
    </div>
  );
}

export function Loading({ label }: { label?: string }) {
  const { t } = useI18n();
  return (
    <div className="status" role="status">
      <span className="spinner" aria-hidden="true" /> {label ?? t("loading")}
    </div>
  );
}
